import { Component, Event, EventEmitter, h, Listen, Prop } from '@stencil/core';
import { ButtonIconType } from '../../utils/icon-types';

@Component({
  tag: 'biel-search-ask-ai-button',
  styleUrl: 'biel-search-ask-ai-button.css',
  shadow: true,
})
export class BielSearchAskAiButton {
  @Prop() resultTitle: string;
  @Prop() resultFragment: string;
  @Prop() isSelected: boolean;
  @Prop() bielId: string;
  @Prop() aiIcon: ButtonIconType = 'bot';

  @Event() askAiClicked: EventEmitter<{ bielId: string }>;

  @Listen('keydown', { target: 'window' })
  handleKeyDown(event: KeyboardEvent) {
    if (this.isSelected && event.key === 'Enter') {
      event.preventDefault();
      this.handleAskAiClick();
    }
  }

  handleAskAiClick() {
    this.askAiClicked.emit({ bielId: this.bielId });
  }

  render() {
    return (
      <a
        class="biel-search-ask-ai"
        tabIndex={this.isSelected ? 0 : -1}
        onClick={() => this.handleAskAiClick()}
      >
        <div class={`biel-search-ask-ai-container ${this.isSelected ? 'selected' : ''}`}>
          <div class="biel-search-ask-ai-icon">
            <biel-icon type={this.aiIcon} width="24" height="24"></biel-icon>
          </div>
          <div class="biel-search-ask-ai-text-container">
            <span class="biel-search-ask-ai__title">{this.resultTitle}</span>
            <span class="biel-search-ask-ai__description">{this.resultFragment}</span>
          </div>
        </div>
      </a>
    );
  }
}
